import { render } from "./App.vue?vue&type=template&id=1d7250a2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Coding/projects/beulco-website-typo3-13lts/extensions/user_blog/Resources/Private/Vue/blog-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__